import { useApplicationModals } from "app/common/hooks";
import { useCollector, useCreateForm } from "app/integration/common/hooks";
import * as Yup from "yup";
import api from "app/integration/api";
import { ModalMolecule } from "app/components/molecules/modal";
import { Formik } from "formik";
import { InputMolecule } from "app/components/molecules/form";
import { Button } from "app/components/atoms/button";
import {
  SelectMolecule,
  SelectSearchMolecule,
} from "app/components/molecules/select";
import { Select } from "app/components/atoms/select";
import { DateTime } from "luxon";
import AppModals from ".";
import { useEffect, useState } from "react";

function CreateCreditModal({ onSuccess = () => {} }) {
  const { showStates, closeModal, getPayloads } = useApplicationModals();
  const payloads = getPayloads("credit.create");

  const handleClose = () => closeModal("credit.create");
  const handleSuccess = () => {
    closeModal("credit.create");
    onSuccess();
  };

  const now = DateTime.now();
  const dt = now.toISODate();
  const time = now.toLocaleString(DateTime.TIME_24_SIMPLE);

  const [customerParams, setCustomerParams] = useState({
    search: "",
    page: 1,
    limit: Number(process.env.REACT_APP_CUSTOMER_LIMIT),
  });

  const [customers, setMCustomers, customersLoader, collectMCustomers] =
    useCollector({ modelName: "customer", params: customerParams });

  useEffect(() => {
    collectMCustomers(customerParams);
  }, [customerParams]);

  var isError = false;
  const { openModal, setPayloads } = useApplicationModals();

  const { initialValues, validationSchema, onSubmit } = useCreateForm({
    initialValues: {
      customerId: "",
      method: 0,
      refNumber: "",
      bankName: "",
      accountNumber: "",
      amount: 0,
      desc: "",
      creditType: 1,
    },
    validationSchema: Yup.object().shape({
      customerId: Yup.string().required("Customer harus dipilih"),
      method: Yup.string().required("Tambah / Kurang Kredit harus dipilih"),
      refNumber: Yup.string().when("method", {
        is: (method) => method?.toUpperCase() === "BANK",
        then: Yup.string(),
      }),
      bankName: Yup.string().when("method", {
        is: (method) => method?.toUpperCase() === "BANK",
        then: Yup.string(),
      }),
      accountNumber: Yup.string().when("method", {
        is: (method) => method?.toUpperCase() === "BANK",
        then: Yup.string(),
      }),
      amount: Yup.number()
        .required("Jumlah Kredit harus diisi")
        .min(1, "Jumlah Kredit harus lebih dari 0."),
      desc: Yup.string(),
      creditType: Yup.string(),
    }),
    onSubmit: async (values) => {
      await api.credit
        .store(
          values.customerId,
          values.method,
          values.refNumber,
          values.bankName,
          values.accountNumber,
          values.amount,
          values.desc,
          values.creditType
        )
        .catch((error) => {
          // console.log("eror: ", error);
          setPayloads("errorMessage.view", {
            title: "Tambah / Kurang Kredit Error",
            message:
              error?.response.status === 400
                ? "Gagal Ubah Kredit. " + error?.response?.data?.message
                : error?.response?.data?.message,
          });
          isError = true;
          openModal("errorMessage.view");
        });
    },
    onSuccess: () => {
      if (!isError) {
        handleSuccess();
      }
    },
  });

  return (
    <ModalMolecule
      show={showStates["credit.create"]}
      title="Tambah / Kurang Kredit"
      onClose={handleClose}
    >
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form className="space-y-4" onSubmit={handleSubmit} >
            <SelectMolecule testId="modal-create-credit-credittype-select"
              placeholder="Pilih salah satu"
              name="creditType"
              label="Tambah / Kurang Kredit"
              value={values.creditType}
              onChange={handleChange}
              options={[
                {
                  value: 1,
                  label: "Tambah Kredit",
                },
                {
                  value: 2,
                  label: "Kurang Kredit",
                },
              ]}
            />
            <SelectSearchMolecule testId="modal-create-credit-customerid-select"
              label="Customer"
              name="customerId"
              options={
                customers?.map((customer) => ({
                  value: customer.id,
                  label:
                    customer.firstName +
                    " " +
                    customer.middleName +
                    " " +
                    customer.lastName +
                    (customer.nickName ? " (" + customer.nickName + ")" : "") +
                    (customer.phone ? " - " + customer.phone + "" : ""),
                }))
              }
              onChange={(e) => {
                console.log("value: ", e.target.value);
                handleChange(e);
              }}
              onSearch={(text) => {
                setCustomerParams({ ...customerParams, search: text });
              }}
              apiSearch={true}
              onBlur={handleBlur}
              value={values.customerId}
              errorMessage={
                errors.customerId && touched.customerId && errors.customerId
              }
            />
            <InputMolecule testId="modal-create-credit-amount-input"
              label="Jumlah Kredit"
              type="number"
              name="amount"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.amount}
              errorMessage={errors.amount && touched.amount && errors.amount}
            />
            <InputMolecule testId="modal-create-credit-desc-input"
              label="Catatan"
              type="text"
              name="desc"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.desc}
              errorMessage={errors.desc && touched.desc && errors.desc}
            />
            <div className="grid grid-cols-2 gap-2">
              <SelectMolecule testId="modal-create-credit-method-select"
                placeholder="Pilih salah satu"
                name="method"
                label="Metode Pembayaran"
                value={values.method}
                onChange={handleChange}
                options={[
                  {
                    value: 1,
                    label: "Bank Transfer",
                  },
                  {
                    value: 2,
                    label: "E-Wallet",
                  },
                  {
                    value: 3,
                    label: "Tunai",
                  },
                ]}
              />
              <InputMolecule testId="modal-create-credit-refnumber-input"
                label="Nomor Referensi"
                type="text"
                name="refNumber"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.refNumber}
                errorMessage={
                  errors.refNumber && touched.refNumber && errors.refNumber
                }
              />
              <InputMolecule testId="modal-create-credit-bankname-input"
                label="Nama Bank"
                type="text"
                name="bankName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.bankName}
                errorMessage={
                  errors.bankName && touched.bankName && errors.bankName
                }
              />
              <InputMolecule testId="modal-create-credit-accountnumber-input"
                label="No. Account"
                type="text"
                name="accountNumber"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.accountNumber}
                errorMessage={
                  errors.accountNumber &&
                  touched.accountNumber &&
                  errors.accountNumber
                }
              />
            </div>
            <div></div>
            <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
              <Button testId="modal-create-credit-register-kredit-button" type="submit">Register Kredit</Button>
            </div>
          </form>
        )}
      </Formik>
    </ModalMolecule>
  );
}

export default CreateCreditModal;
